import { Injectable } from '@angular/core';
import DateBox from "devextreme/ui/date_box";

@Injectable({ providedIn: 'root' })
export class DatePickerService {

    constructor() { }

    onEditorPreparingMethod(event: any) {
        if (event.dataType == "date") {
            let rowIndex = event?.row?.rowIndex !== undefined ? event?.row?.rowIndex : 'default';
            event.editorOptions = {
              elementAttr: {
                id: `current-${event.dataField}-date-${rowIndex}`
              },
              onValueChanged: (args: any) => {
                if(event.row) {
                  event.row.data[event.dataField] = args.value;
                } else {
                    event.setValue(args.value);
                }
              },
              dropDownOptions: {
                toolbarItems: [
                  {
                    toolbar: "bottom",
                    widget: "dxButton",
                    cssClass: 'grid-date-picker-btn-secondary',
                    options: {
                      text: `Select "Today" (${new Date().toLocaleDateString('en-GB')})`,
                      onClick: function() {
                        const dateBox = DateBox.getInstance(
                          document.getElementById(`current-${event.dataField}-date-${rowIndex}`)
                        ) as DateBox;
                        dateBox.option("value", new Date());
                        dateBox.close();
                      }
                    }
                  }
                ]
              }
            }
        }
    }

    getMonth() {
      const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
      return months[new Date().getMonth()];
    }

}
